import React from "react";
import { Link } from "react-router-dom";

import eventrefsinfo from "../../assets/refs";
import eventRefs from "../../assets/eventRef";
import InputText from "../../components/common/inputs/textInput";
import SelectGroupText from "../../components/common/inputs/selectGroupInput";
import SelectInput from "../../components/common/inputs/selectInput";
import Loading from "../../components/common/loading";
import RowList from "../../components/common/rowList";
import Fields from "../../components/common/inputs/target-web-inputs/inputsIndex";
import ModalManager from "../../components/common/modal/ModalManager";
import { AppPage, AppPageHeader } from "../../components/common/appShell";
import {
  CUSTOM_FUNCTION_ACTION_CODE,
  getCustomFunctionPresetById,
  getCustomFunctionPresetOptions,
} from "../../assets/customFunctionPresets";
import { apiErrorMessageFromError } from "../../utils/apiErrorMessage";
import { isApiVersionGte } from "../../utils/deviceApiVersion";
import { getNetworkInterfaceOptions } from "../../utils/networkInterfaces";
import {
  buildActionParamsForSave,
  buildAlertDetailsPath,
  buildDeviceAlertsPath,
  getActionFormStateForEditing,
  getActionParamRows,
  getActionRefByCode,
  getActionTypeLabel,
  getDefaultCustomFunctionFormState,
  getEventDescription,
  getEventParamCount,
  hydrateEventDescription,
  isEditableAction,
  normalizeActionParams,
  validateCustomFunctionJsonPayload,
} from "../../utils/deviceAlertUtils";
import axios from "axios";

import { format } from "date-fns";
const { actionRefs, eventCategories, eventCodeModules } = eventrefsinfo;

function buildEventParamsForSave(eventRef, params, apiVersion) {
  const paramCount = getEventParamCount(eventRef?.code, eventRef, apiVersion);
  const paramsToSend = (params || []).slice(0, paramCount);

  if (Number(eventRef?.code) === 12 && typeof paramsToSend[0] === "string") {
    paramsToSend[0] = paramsToSend[0].trim();
  }

  const dynamicNetworkInterfaceParamIndex = (eventRef?.params || [])
    .slice(0, paramCount)
    .findIndex((param) => param.dynamicNetworkInterface);

  if (
    dynamicNetworkInterfaceParamIndex >= 0 &&
    isApiVersionGte(apiVersion, "1.2") &&
    !paramsToSend[dynamicNetworkInterfaceParamIndex]
  ) {
    paramsToSend[dynamicNetworkInterfaceParamIndex] = "default";
  }

  return paramsToSend;
}

const editorGridStyle = {
  alignItems: "start",
  display: "grid",
  gap: "20px 24px",
  gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 520px), 1fr))",
};

const editorColumnStyle = {
  maxWidth: "none",
  minWidth: 0,
  width: "100%",
};

const editorFullWidthStyle = {
  gridColumn: "1 / -1",
  maxWidth: "none",
  width: "100%",
};

export {
  buildActionParamsForSave,
  buildEventParamsForSave,
  getActionFormStateForEditing,
  isEditableAction,
};

function getEventIdFromProps(props = {}) {
  return (
    props.eventId ??
    props.match?.params?.section_id ??
    props.match?.params?.eventId ??
    null
  );
}

function getSerialFromProps(props = {}) {
  return (
    props.enclosureSerialNumber ??
    props.match?.params?.enclosureSerialNumber ??
    props.device?.enclosureSerialNumber ??
    null
  );
}

export default class DeviceAlertItemPage extends React.Component {
  actionsRequest = null;
  groupsRequest = null;

  state = {
    id: null,

    name: null,
    eventCode: null,
    actions: [],
    params: ["", "", ""],

    numTicksBeyond: 0,
    timeExecutedInEpoch: 0,
    triggered: null,
    stale: false,

    newActionFormActive: false,
    newActionFormId: null,
    newActionName: "",
    newActionCode: null,
    newActionParams: ["", "", ""],
    ...getDefaultCustomFunctionFormState(),

    eventFormHasChanges: false,
    actionFormHasChanges: false,

    activeActionDetailsSectionIndex: null,

    eventSaving: false,
    eventSaved: false,
    eventErrorMessage: "",

    actionSaving: false,
    actionSaved: false,

    addedActions: [],
    actionsLoading: false,
    actionsLoaded: false,

    deleteLoading: false,

    groups: [],
    groupsLoading: false,
  };

  getEventId = (props = this.props) => getEventIdFromProps(props);

  getSerial = (props = this.props) => getSerialFromProps(props);

  isNewEvent = (props = this.props) => this.getEventId(props) === "new";

  getAlertsPath = (props = this.props) =>
    props.alertsPath || buildDeviceAlertsPath(this.getSerial(props));

  getDetailsPath = (eventId = this.getEventId(), props = this.props) =>
    props.detailsPath || buildAlertDetailsPath(this.getSerial(props), eventId);

  saveEventChanges = () => {
    if (this.state.eventSaving) {
      console.warn("cannot save event changes, event is already saving");
      return;
    }
    if (this.state.actionFormHasChanges) {
      console.warn("cannot save event changes, action form has changes");
      return;
    }
    this.setState({
      eventSaving: true,
      eventErrorMessage: "",
    });
    const enclosureSerialNumber = this.getSerial();
    const eventId = this.getEventId();
    if (eventId === "new") {
      const { name, eventCode, actions, params } = this.state;
      const { actionsLoading } = this.state;
      const eventRef = eventRefs.find((e) => e.code == eventCode);
      const paramsToSend = buildEventParamsForSave(
        eventRef,
        params,
        this.props.device?.apiVersion,
      );
      if (actionsLoading) {
        console.warn("actions still loading, cannot save event");
        this.setState({
          eventSaving: false,
        });
        return;
      }
      const actionIds = actions;
      const newEvent = {
        name,
        code: eventCode,
        actions: actionIds,
        params: paramsToSend,
      };

      this.props.createEvent(
        enclosureSerialNumber,
        newEvent,
        (err, data) => {
          if (err) {
            const errorMessage = apiErrorMessageFromError(
              err,
              "Failed to create event."
            );
            this.setState({
              eventSaving: false,
              eventSaved: false,
              eventErrorMessage: errorMessage,
            });
            console.error("error creating event", err);
            return;
          } else {
            this.setState({
              eventSaving: false,
              eventSaved: true,
              eventErrorMessage: "",
            });
            this.props.history.push(this.getDetailsPath(data.id));
            this.setState({
              eventFormHasChanges: false,
              eventErrorMessage: "",
            });
          }
        }
      );
    } else {
      const event = this.props.events.find(e => e.id == eventId);

      if (event) {
        const { name, eventCode, actions, params } = this.state;
        const { actionsLoading } = this.state
        const eventRef = eventRefs.find((e) => e.code == eventCode);
        const paramsToSend = buildEventParamsForSave(
          eventRef,
          params,
          this.props.device?.apiVersion,
        );
        if (actionsLoading) {
          console.warn("actions still loading, cannot save event");
          this.setState({
            eventSaving: false,
          });
          return;
        }
        const actionIds = actions;
        const newEvent = {
          name,
          code: eventCode,
          actions: actionIds,
          params: paramsToSend,
        };

        this.props.updateEvent(
          enclosureSerialNumber,
          eventId,
          newEvent,
          (err, data) => {
            if (err) {
              const errorMessage = apiErrorMessageFromError(
                err,
                `Failed to update event ${eventId}`
              );
              this.setState({
                eventSaving: false,
                eventSaved: false,
                eventErrorMessage: errorMessage,
              });
              console.error("error updating event", err);
              return;
            } else {
              this.setState({
                eventSaving: false,
                eventSaved: true,
                eventFormHasChanges: false,
                eventErrorMessage: "",
              });
            }
          }
        )
      } else {
        this.setState({
          eventSaving: false,
        });
        console.warn("event not found in save event changes");
      }
    }
  };

  deleteEvent = (
    enclosureSerialNumber,
  ) => {

    this.setState({
      deleteLoading: true,
    })
    this.props.removeEvent(
      this.getSerial(),
      this.state.id,
      (err, data) => {
        this.setState({
          deleteLoading: false,
        });
        if (err) {
          console.error("error deleting event", err);
          alert("Error occurred");
          return;
        } else {
          this.props.history.push(this.getAlertsPath());
        }
      }
    );

  }

  setEventFormState = (newState) => {
    this.setState({
      ...newState,
      eventErrorMessage: "",
    });
  };

  resetEventChanges = () => {
    this.loadFoundeventInfo();
    this.setState({
      eventFormHasChanges: false,
      eventErrorMessage: "",
    });
  };
  resetActionChanges = () => {
    this.setState({
      actionFormHasChanges: false,
      newActionName: "",
      newActionCode: null,
      newActionParams: ["", "", ""],
      ...getDefaultCustomFunctionFormState(),
    });
  };

  loadFoundeventInfo = () => {
    const eventId = this.getEventId();
    const event = this.props.events.find((existingEvent) => existingEvent.id == eventId);

    if (event) {
      this.setState({
        id: event.id,
        name: event.name,
        eventCode: event.code,
        actions: event.actions || [],
        params: event.params,
        numTicksBeyond: event.numTicksBeyond,
        timeExecutedInEpoch: event.timeExecutedInEpoch,
        triggered: event.triggered,
        stale: Boolean(event.stale),
        eventErrorMessage: "",
      });
    } else {
      console.warn("event not found in mount");
      this.setState({ stale: false, eventErrorMessage: "" });
    }
  };


  grabActions = () => {
    if (this.actionsRequest) {
      return this.actionsRequest;
    }
    this.setState({
      actionsLoading: true,
      actionsLoaded: false,
    });
    this.actionsRequest = axios
      .get(`/v1/actions?enclosure_serial_number=${this.getSerial()}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }).then(response => {
        this.setState({
          addedActions: response.data.data,
          actionsLoading: false,
          actionsLoaded: true
        })
        return response.data.data;
      }).catch(err => {
        console.error("error fetching actions", err);
        this.setState({
          actionsLoading: false,
        });
        return [];
      }).finally(() => {
        this.actionsRequest = null;
      });

    return this.actionsRequest;

  }
  fetchGroups = () => {
    const serial = this.props.device?.enclosureSerialNumber;
    if (!serial) return;
    if (this.groupsRequest) return this.groupsRequest;
    this.setState({ groupsLoading: true });
    this.groupsRequest = axios
      .get(`/v1/devices/${serial}/outlet-groups`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((res) => {
        this.setState({ groups: res.data.data || [], groupsLoading: false });
        return res.data.data || [];
      })
      .catch((err) => {
        console.error(err);
        this.setState({ groupsLoading: false });
        return [];
      })
      .finally(() => {
        this.groupsRequest = null;
      });
    return this.groupsRequest;
  };
  componentDidMount() {
    this.grabActions();
    this.loadFoundeventInfo();
    this.fetchGroups();
  }

  componentDidUpdate(prevProps, prevState) {
    const eventsChanged = prevProps.events !== this.props.events;
    const sectionChanged = this.getEventId(prevProps) !== this.getEventId();

    if (eventsChanged || sectionChanged) {
      const sectionId = this.getEventId();
      const event = this.props.events.find((e) => e.id == sectionId);

      if (event && event.id !== this.state.id) {
        this.loadFoundeventInfo();
      }
    }

    const eventFormInputsChanged =
      prevState.name !== this.state.name ||
      prevState.eventCode !== this.state.eventCode ||
      prevState.numTicksBeyond !== this.state.numTicksBeyond ||
      prevState.timeExecutedInEpoch !== this.state.timeExecutedInEpoch ||
      prevState.triggered !== this.state.triggered ||
      JSON.stringify(prevState.params || []) !==
        JSON.stringify(this.state.params || []) ||
      JSON.stringify(prevState.actions || []) !==
        JSON.stringify(this.state.actions || []);

    if (this.state.eventErrorMessage && eventFormInputsChanged) {
      this.setState({ eventErrorMessage: "" });
    }
  }

  triggerOptions() {
    const {device, banks} = this.props;
    if (!device) return;
    var allowableEventCodes = [...eventCodeModules.codesForEveryone];
    allowableEventCodes.push(...eventCodeModules.multiBankEventCodes);

    if (device.phase == "Single Phase") {
      allowableEventCodes.push(...eventCodeModules.singlePhaseEventCodes);
    } else if (
      device.phase === "Three Phase Delta" ||
      device.phase === "Three Phase Delta+Wye" ||
      device.phase === "Three Phase Wye"
    ) {
      allowableEventCodes.push(...eventCodeModules.threePhaseEventCodes);
    }

    if (
      device.outletPwrMeasurementsSupported &&
      device.outletSwitchingSupported
    ) {
      allowableEventCodes.push(...eventCodeModules.outletEventCodes);
    }

    if (device.inletConfig == "ats") {
      allowableEventCodes.push(...eventCodeModules.atsEventCodes);
    }

    if (
      banks[0] &&
      banks[0].hasCircuitBreakerProtection &&
      device.inletEnergySupported
    ) {
      allowableEventCodes.push(...eventCodeModules.circuitBreakerCodes);
    }
    //remove non-current event codes
    if (device.inletCurrentSupported) {
      allowableEventCodes = allowableEventCodes.filter((e) => {
        return !eventCodeModules.nonInletCurrentEventCodes.includes(e);
      });
    }
    const triggerOptions = eventRefs.map((e) => ({
      label: e.name,
      value: e.code,
    }));
    return triggerOptions;
  }
  saveActionButton = (callback = () => {}) => {
    if (this.state.actionSaving) {
      console.warn("cannot save action, action is already saving");
      return;
    }
    this.setState({
      actionSaving: true,
      eventErrorMessage: "",
    });

    const enclosureSerialNumber = this.getSerial();
    const { newActionName, newActionCode, newActionParams } = this.state;
    const paramsToSend = buildActionParamsForSave(
      newActionCode,
      newActionParams,
      {
        isUpdate: Boolean(this.state.newActionFormId),
        replaceScript: this.state.replaceCustomFunctionScript,
      },
    );
    if (!paramsToSend) {
      const validationErr =
        newActionCode === CUSTOM_FUNCTION_ACTION_CODE
          ? validateCustomFunctionJsonPayload((newActionParams || [])[1] || "")
          : "";
      this.setState({
        actionSaving: false,
      });
      alert(
        validationErr ||
          "Select a custom function script preset before saving this action."
      );
      return;
    }
    const newAction = {
      name: newActionName,
      code: newActionCode,
      params: paramsToSend,
    };

    if (this.state.newActionFormId) {
      axios
        .put(
          `/v1/devices/${enclosureSerialNumber}/actions/${this.state.newActionFormId}`,
          newAction,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        ).then((response) => {
          this.setState({
            actionSaving: false,
          });
          this.setState(
            {
              newActionFormActive: false,
              newActionFormId: null,
              newActionName: "",
              newActionCode: null,
              newActionParams: ["", "", ""],
              ...getDefaultCustomFunctionFormState(),
              actionFormHasChanges: false,

              addedActions: this.state.addedActions.map((a) => {
                if (a.id == response.data.data.id) {
                  return ({
                    ...a,
                    ...response.data.data,
                  });
                } else {
                  return a;
                }
              }),
            },
            () => {
              if (this.state.eventFormHasChanges) {
                this.saveEventChanges();
              }
            }
          );
          callback(null, response.data.data);
        }).catch((err) => {
          const message = apiErrorMessageFromError(
            err,
            "Failed to update action.",
          );
          this.setState({
            actionSaving: false,
            eventErrorMessage: message,
          });
          console.error("error updating action", err);
          callback(err, null);
        });

    } else {

      // create new action
      axios
        .post(
          `/v1/devices/${enclosureSerialNumber}/actions`,
          newAction,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        ).then((response) => {
          const newActionId = response.data?.data?.id;
          if (!newActionId) {
            console.error("error creating action, no id returned", response);
            this.setState({
              actionSaving: false,
            });
            return;
          }
          this.setState(
            {
              actionSaving: false,
              newActionFormActive: false,
              newActionFormId: null,
              newActionName: "",
              newActionCode: null,
              newActionParams: ["", "", ""],
              ...getDefaultCustomFunctionFormState(),
              actionFormHasChanges: false,

              addedActions: [...this.state.addedActions, response.data.data],
              actions: [...this.state.actions, newActionId],
              eventFormHasChanges: true

            },
            () => {
              if (!this.isNewEvent()) {
                this.saveEventChanges();
              }
            }
          );
        }).catch((err) => {
          const message = apiErrorMessageFromError(
            err,
            "Failed to create action.",
          );
          this.setState({
            actionSaving: false,
            eventErrorMessage: message,
          });
          console.error("error creating action", err);
          callback(err, null);
        });
    }
  };
  deleteAction = (actionId) => {
    ModalManager.confirm(
      "Are you sure you want to delete this action? It will be removed permanently from the device AND from any events which use this action.",
      "Confirm Removal of Action",
      "Remove",
      (status, close) => {
        if (status) {
          // clicked sign in
          const enclosureSerialNumber = this.getSerial();
          axios.delete(
            `/v1/devices/${enclosureSerialNumber}/actions/${actionId}`,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          ).then((response) => {
            this.setState({
              actions: this.state.actions.filter((a) => a !== actionId),
            });
            close();
          }).catch((err) => {
            console.error("error deleting action", err);
            alert("Error occurred");
          })
        } else {
          // clicked cancel or outside

        }
      },
      null,
      false
    );
  };

  renderSkeletonLine = (style = {}) => (
    <div
      className="skeleton-blank"
      style={{
        boxSizing: "border-box",
        marginTop: "0px",
        ...style,
      }}
    />
  );

  renderSkeletonFormField = (labelWidth = "24%") => (
    <div style={{ marginBottom: "16px" }}>
      {this.renderSkeletonLine({
        width: labelWidth,
        marginBottom: "8px",
      })}
      {this.renderSkeletonLine({
        width: "100%",
        minHeight: "34px",
        marginBottom: "0px",
      })}
    </div>
  );

  renderAlertDetailsSkeleton = () => (
    <div style={{ marginBottom: "10px" }}>
      <div
        className="config-header section"
        style={{ display: "flex", alignItems: "center" }}
      >
        <h4 className="config-header-title section">Alert Details</h4>
      </div>
      <div className="app-item" aria-busy="true">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "12px",
            alignItems: "flex-start",
            flexWrap: "wrap",
            marginBottom: "12px",
          }}
        >
          <div style={{ flex: "1 1 260px", minWidth: 0 }}>
            {this.renderSkeletonLine({
              width: "52%",
              marginBottom: "8px",
            })}
            {this.renderSkeletonLine({
              width: "92%",
              marginBottom: "8px",
            })}
            {this.renderSkeletonLine({
              width: "70%",
              marginBottom: "0px",
            })}
          </div>
          {this.renderSkeletonLine({
            width: "86px",
            marginBottom: "0px",
          })}
        </div>
        <div style={{ borderTop: "1px solid var(--border-color)" }}>
          {["34%", "56%", "86%", "48%"].map((width, index) => (
            <div
              key={index}
              style={{
                borderBottom: "1px solid var(--border-color)",
                display: "grid",
                gridTemplateColumns: "minmax(120px, 1fr) minmax(160px, 1fr)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    index % 2 === 0
                      ? "var(--surface-muted-color)"
                      : "var(--surface-color)",
                  borderRight: "1px solid var(--border-color)",
                  padding: "12px",
                }}
              >
                {this.renderSkeletonLine({
                  width: "40%",
                  marginBottom: "0px",
                })}
              </div>
              <div style={{ padding: "12px" }}>
                {this.renderSkeletonLine({
                  width,
                  marginBottom: "0px",
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  renderEventSettingsSkeleton = () => (
    <React.Fragment>
      <div>
        <div className="config-header section">
          <h4 className="config-header-title section">Event Settings</h4>
        </div>
        <div
          className="app-item"
          aria-busy="true"
          style={{ marginBottom: "10px", minHeight: "172px" }}
        >
          {this.renderSkeletonFormField("20%")}
          {this.renderSkeletonFormField("18%")}
        </div>
      </div>
      <div style={{ marginBottom: "10px" }}>
        <div className="config-header section">
          <h4 className="config-header-title section">Alert Condition</h4>
        </div>
        <div
          className="app-item"
          aria-busy="true"
          style={{
            padding: "18px",
            borderRadius: "0px 0px 3px 3px",
            minHeight: "154px",
          }}
        >
          {this.renderSkeletonFormField("26%")}
          {this.renderSkeletonLine({
            width: "74%",
            marginBottom: "0px",
          })}
        </div>
      </div>
    </React.Fragment>
  );

  renderAddActionSkeleton = () => (
    <div style={{ marginBottom: "10px" }}>
      <div className="config-header section">
        <h4 className="config-header-title section">Add Action</h4>
      </div>
      <div
        className="app-item"
        aria-busy="true"
        style={{
          padding: "18px",
          borderRadius: "0px 0px 3px 3px",
          minHeight: "153px",
        }}
      >
        {this.renderSkeletonFormField("34%")}
        {this.renderSkeletonLine({
          width: "8%",
          marginBottom: "10px",
        })}
        {this.renderSkeletonLine({
          width: "28%",
          marginBottom: "0px",
        })}
      </div>
    </div>
  );

  renderActionsListSkeleton = () => (
    <React.Fragment>
      <div className="config-header section">
        <h4 className="config-header-title section">
          List of Actions for Event
        </h4>
      </div>
      <div className="app-item" aria-busy="true" style={{ minHeight: "90px" }}>
        <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          {this.renderSkeletonLine({ width: "38%" })}
          {this.renderSkeletonLine({ width: "66%" })}
          {this.renderSkeletonLine({ width: "48%", marginBottom: "0px" })}
        </div>
      </div>
    </React.Fragment>
  );

  render() {
    const eventId = this.getEventId();
    const serial = this.getSerial();
    const newEvent = this.isNewEvent();
    const triggerOptions = this.triggerOptions();
    const event = this.props.events.find((existingEvent) => existingEvent.id == eventId);
    const eventLoading = !newEvent && !event;
    const alertsPath = this.getAlertsPath();

    const {
      events,
      device,
    } = this.props;
   
    const actions = this.state.addedActions
    const actionsLoading = this.state.actionsLoading;
    const actionsLoaded = this.state.actionsLoaded;
    const deviceApiVersion = device?.apiVersion;
    
    const filteredActionRefs = device
      ? actionRefs.filter((a) => {
          if (
            a.code === CUSTOM_FUNCTION_ACTION_CODE &&
            !isApiVersionGte(deviceApiVersion, "1.2")
          ) {
            return false;
          }
          if (
            (a.code == 22 || a.code == 23) &&
            (!device.numDryContactRelays ||
              device.numDryContactRelays == 0)
          ) {
            return false;
          } else if (a.code == 31 && !device.inletEnergySupported) {
            return false;
          } else if (
            device.outletPwrMeasurementsSupported ||
            device.outletSwitchingSupported
          ) {
            return true;
          } else {
            return !a.outletFeature;
          }
        })
      : [];

    const foundEventRef = eventRefs.find((e) => e.code == event?.code);
    const hydratedFoundEventRefDesc = event ? getEventDescription(event) : "";
    const triggerConditionDescription = event
      ? hydrateEventDescription(
          foundEventRef?.triggeredDescription,
          event.params || [],
          event.code,
          foundEventRef,
        )
      : "";
    const headerTitle = newEvent ? "Create alert" : "Edit alert";
    const headerDescription = newEvent
      ? "Define the alert condition and the actions that should run when the condition is met."
      : "Adjust the alert condition and the actions that run when this alert triggers.";
    const triggerTimeLabel =
      event?.triggered && event?.timeExecutedInEpoch
        ? format(event.timeExecutedInEpoch * 1000, "MMM dd, yyyy HH:mm")
        : "";
    const editSummaryFields = [
      {
        label: "Status",
        valueComponent: (
          <span
            style={{
              fontWeight: "600",
              color: event?.triggered
                ? "var(--danger-color)"
                : "var(--success-color)",
            }}
          >
            {event?.triggered ? "Triggered" : "Clear"}
          </span>
        ),
      },
      {
        label: "Event type",
        value: foundEventRef?.name || "Unknown Event Type",
      },
      {
        label: "Current condition",
        value:
          hydratedFoundEventRefDesc ||
          triggerConditionDescription ||
          "Current alert condition information is unavailable.",
      },
      {
        label: "Last trigger",
        value: triggerTimeLabel || "Not currently triggered",
      },
    ];

    return (
      <AppPage>
        <AppPageHeader
          title={headerTitle}
          description={headerDescription}
          actions={
            <React.Fragment>
              <Link
                to={alertsPath}
                className="button secondary"
                style={{ marginBottom: "0px" }}
              >
                Back to alerts
              </Link>
              {this.state.eventFormHasChanges && (
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  <button
                    type="button"
                    className="button"
                    style={{
                      opacity: this.state.actionFormHasChanges ? "0.5" : "1",
                      marginBottom: "0px",
                    }}
                    onClick={() => this.saveEventChanges()}
                  >
                    {this.state.eventSaving ? (
                      <Loading white />
                    ) : this.state.id ? (
                      "Save changes"
                    ) : (
                      "Create alert"
                    )}
                  </button>
                  <button
                    type="button"
                    className="button secondary"
                    style={{
                      opacity: this.state.actionFormHasChanges ? "0.5" : "1",
                      marginBottom: "0px",
                    }}
                    onClick={() => {
                      if (!this.state.actionFormHasChanges) {
                        this.resetEventChanges();
                      }
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </React.Fragment>
          }
        />
        <div className="grid-container" style={{ maxWidth: "none", width: "100%" }}>
          <div className="grid-x grid-padding-x grid-padding-y" style={editorGridStyle}>
          {this.state.eventErrorMessage && (
            <div
              className="cell event-editor-error-banner-row"
              data-testid="event-error-banner-row"
              style={{ ...editorFullWidthStyle, marginBottom: "10px" }}
            >
              <div
                className="app-item"
                style={{
                  marginBottom: "0px",
                  color: "#991b1b",
                  backgroundColor: "#fef2f2",
                  border: "1px solid #fecaca",
                  whiteSpace: "pre-line",
                }}
              >
                {this.state.eventErrorMessage}
              </div>
            </div>
          )}
          <div className="cell large-6 medium-6" style={editorColumnStyle}>
            {event && (
              <div
                style={{
                  marginBottom: "10px",
                }}
              >
                <div
                  className="config-header section"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <h4 className="config-header-title section">Alert Details</h4>
                </div>
                <div className="app-item">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "12px",
                      alignItems: "flex-start",
                      flexWrap: "wrap",
                      marginBottom: "12px",
                    }}
                  >
                    <div style={{ flex: "1 1 260px", minWidth: 0 }}>
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          marginBottom: "4px",
                        }}
                      >
                        {event.name}
                      </div>
                      <div style={{ color: "var(--text-muted-color)", lineHeight: 1.5 }}>
                        {event.triggered
                          ? `This alert is currently active. ${triggerConditionDescription || hydratedFoundEventRefDesc}`
                          : `This alert is currently clear. It is configured to trigger when ${triggerConditionDescription || "its saved condition becomes true"}.`}
                      </div>
                    </div>
                    <div
                      style={{
                        fontWeight: "600",
                        color: event.triggered
                          ? "var(--danger-color)"
                          : "var(--success-color)",
                      }}
                    >
                      {event.triggered ? "Triggered" : "Clear"}
                    </div>
                  </div>
                  <RowList rows={editSummaryFields} />
                </div>
              </div>
            )}
            {eventLoading ? (
              <React.Fragment>
                {this.renderAlertDetailsSkeleton()}
                {this.renderEventSettingsSkeleton()}
              </React.Fragment>
            ) : (
              <div>
                <div className="config-header section">
                  <h4 className="config-header-title section">
                    Event Settings
                  </h4>
                </div>
                <div className="app-item" style={{ marginBottom: "10px" }}>
                  <InputText
                    label="Event Name"
                    placeholder="eg. 16A Max Current Threshold Inlet"
                    value={
                      this.state.name === null
                        ? event?.name
                        : this.state.name
                    }
                    validation={(value="") => {
                      if (value.length === 0) {
                        return "name is required";
                      }
                      if (value.length > 100) {
                        return "Name is too long";
                      }
                      if (events.find((a) => a.name === value)) {
                        return "Name already exists";
                      }
                      return null;
                    }}
                    callback={(e) =>
                      this.setState({ name: e, eventFormHasChanges: true })
                    }
                  />
                  {device ? (
                    <SelectGroupText
                      label="Event Type"
                      value={
                        this.state.eventCode === null
                          ? event?.code
                          : this.state.eventCode
                      }
                      callback={(result) => {
                        this.setState({
                          eventCode: result,
                          params: ["", "", ""],
                          eventFormHasChanges: true,
                        });
                      }}
                      validation={(value) => {
                        if (!value) {
                          return "Event type is required";
                        }
                        return null;
                      }}
                      options={eventCategories
                        .map((category) => {
                          return {
                            groupName: category.label,
                            options: triggerOptions.filter((option) => {
                              return category.codes.includes(option.value);
                            }),
                          };
                        })
                        .filter((category) => category.options.length > 0)}
                    />
                  ) : (
                    "Loading"
                  )}
                </div>
                <TriggerParamSection
                  {...this.props}
                  setEventFormState={this.setEventFormState}
                  eventForm={this.state}
                />
              </div>
            )}
          </div>
          <div className="cell large-6 medium-6" style={editorColumnStyle}>
            {eventLoading ? (
              <React.Fragment>
                {this.renderAddActionSkeleton()}
                {this.renderActionsListSkeleton()}
              </React.Fragment>
            ) : (
              <React.Fragment>
            {!this.state.newActionFormActive && (
              <div
                style={{
                  marginBottom: "10px",
                }}
              >
                <div className="config-header section">
                  <h4 className="config-header-title section">Add Action</h4>
                </div>
                <div
                  className="app-item"
                  style={{
                    padding: "18px",
                    borderRadius: "0px 0px 3px 3px",
                  }}
                >
                  <SelectInput
                    label="Add Existing Action for Event"
                    callback={(result) =>
                      this.setState({
                        actions: [
                          ...(this.state.actions || []),
                          parseInt(result, 10),
                        ],
                        eventFormHasChanges: true,
                      })
                    }
                    value=""
                    options={actions
                      .filter((a) => !this.state.actions.includes(a.id))
                      .map((a) => ({
                        label: a.name,
                        value: a.id,
                      }))}
                  />
                  <div
                    style={{
                      paddingBottom: "10px",
                    }}
                  >
                    or
                  </div>
                  <div>
                    <div
                      onClick={() => {
                        this.setState({
                          newActionFormActive: true,
                          newActionFormId: null,
                          newActionName: "",
                          newActionCode: null,
                          newActionParams: ["", "", ""],
                          ...getDefaultCustomFunctionFormState(),
                          actionFormHasChanges: false,
                        });
                      }}
                      style={{
                        color: "var(--app-link)",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Create New Action
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.newActionFormActive && (
              <div
                style={{
                  marginBottom: "10px",
                }}
              >
                <div className="config-header section">
                  <h4 className="config-header-title section">
                    {this.state.newActionFormId
                      ? "Edit Action"
                      : "Create New Action"}
                  </h4>
                  <div>
                    {this.state.actionFormHasChanges && (
                      <div
                        className="button"
                        style={{
                          marginRight: "10px",
                          // backgroundColor: "#223647",
                          backgroundColor: "rgb(112, 179, 125)",
                          color: "#fff",
                          marginBottom: "0px",
                        }}
                        onClick={() => {
                          this.saveActionButton();
                        }}
                      >
                        {this.state.actionSaving ? (
                          <Loading white />
                        ) : this.state.newActionFormId ? (
                          "Save"
                        ) : (
                          "Create"
                        )}
                      </div>
                    )}
                    <div
                      className="button"
                      style={{
                        marginBottom: "0px",
                        backgroundColor: "#ddd",
                        color: "#333",
                      }}
                      onClick={() => {
                        this.setState({
                          newActionFormActive: false,
                          newActionFormId: null,
                          newActionName: "",
                          newActionCode: null,
                          newActionParams: ["", "", ""],
                          ...getDefaultCustomFunctionFormState(),
                          actionFormHasChanges: false,
                          activeActionDetailsSectionIndex: null,
                        });
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                </div>
                <div className="app-item">
                  <InputText
                    label="Action Name"
                    placeholder="eg. Switch Outlet"
                    value={this.state.newActionName}
                    callback={(result) =>
                      this.setState({
                        newActionName: result,
                        actionFormHasChanges: true,
                      })
                    }
                  />
                  <SelectInput
                    label="Action Type"
                    value={this.state.newActionCode}
                    callback={(result) => {
                      const nextActionCode = parseInt(result, 10);
                      this.setState({
                        newActionCode: nextActionCode,
                        newActionParams: ["", "", ""],
                        replaceCustomFunctionScript:
                          nextActionCode === CUSTOM_FUNCTION_ACTION_CODE,
                        currentCustomFunctionScriptName: "",
                        actionFormHasChanges: true,
                      });
                    }}
                    options={filteredActionRefs.map((a) => ({
                      label: a.name,
                      value: a.code,
                    }))}
                  />
                  <div
                    style={{
                      borderBottom: "solid rgba(0,0,0,0.1) 1px",
                      marginBottom: "10px",
                      marginRight: "15px",
                      marginLeft: "15px",
                    }}
                  />
                  <ActionParamSection
                    {...this.props}
                    groups={this.state.groups}
                    actionForm={{
                      name: this.state.newActionName,
                      code: this.state.newActionCode,
                      params: this.state.newActionParams,
                    }}
                    actionFormId={this.state.newActionFormId}
                    replaceCustomFunctionScript={
                      this.state.replaceCustomFunctionScript
                    }
                    currentCustomFunctionScriptName={
                      this.state.currentCustomFunctionScriptName
                    }
                    setEventFormState={this.setEventFormState}
                  />
                </div>
              </div>
            )}

            <div className="config-header section">
              <h4 className="config-header-title section">
                List of Actions for Event
              </h4>
            </div>
            {actions.length === 0 && actionsLoading && (
              <div className="app-item">
                <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                  {/* <Loading black />  */}
                  <div className="skeleton-blank" style={{ width: "45%" }} />
                  <div className="skeleton-blank" style={{ width: "70%" }} />
                  <div className="skeleton-blank" style={{ width: "55%" }} />
                </div>
              </div>
            )}
            {this.state.actions.length === 0 && actionsLoaded && (
              <div className="app-item">
                <div
                  style={{
                    padding: "10px",
                    borderRadius: "0px 0px 3px 3px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      // justifyContent: "center",
                      alignItems: "center",
                      // marginBottom: "10px",
                    }}
                  >
                    No Actions Included
                  </div>
                </div>
              </div>
            )}
            {this.state.actions.map((actionId, actionIndex) => {
              const foundAction = actions.find(
                (a) => a.id == actionId
              );
              if (!foundAction) {
                return null;
              }
              const actionRef = getActionRefByCode(foundAction.code);
              const actionTypeLabel = getActionTypeLabel(foundAction.code);
              const actionParamRows = getActionParamRows(foundAction);
              const actionIsEditable = isEditableAction(foundAction);
              return (
                <div
                  key={actionIndex}
                  style={{
                    marginBottom: "5px",
                  }}
                >
                  {/* <div className="config-header section">
                    <h4 className="config-header-title section">
                      {actionRef.name}
                    </h4>
                  </div> */}
                  <div
                    className="app-item"
                    style={{
                      padding: "18px",
                      borderRadius: "0px 0px 3px 3px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      this.setState({
                        activeActionDetailsSectionIndex:
                          this.state.activeActionDetailsSectionIndex ===
                          actionIndex
                            ? null
                            : actionIndex,
                      });
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <div>{actionTypeLabel} Action</div>
                        <div
                          style={{
                            fontWeight: "600",
                          }}
                        >
                          {foundAction.name}
                        </div>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {/* dropdown */}
                        <span style={{}}>
                          <i className="material-icons">
                            {this.state.activeActionDetailsSectionIndex ===
                            actionIndex
                              ? "expand_less"
                              : "expand_more"}
                          </i>
                        </span>
                      </div>
                    </div>
                    {this.state.activeActionDetailsSectionIndex ===
                      actionIndex && (
                      <div
                        style={{
                          paddingLeft: "10px",
                        }}
                      >
                        <div
                          style={{
                            borderBottom: "solid rgba(0,0,0,0.08) 1px",
                            // marginBottom: "10px",
                            marginRight: "5px",
                            marginLeft: "5px",
                            marginTop: "10px",
                          }}
                        />
                        <div
                          style={{
                            paddingBottom: "5px",
                          }}
                        >
                          {actionParamRows.map((row) => {
                            return (
                              <div
                                key={row.key}
                                style={{
                                  padding: "10px 0px 0px 0px",
                                }}
                              >
                                <div
                                  style={{
                                    paddingBottom: "5px",
                                    fontSize: "90%",
                                  }}
                                >
                                  {row.label}:
                                </div>
                                <div
                                  style={{
                                    fontWeight: "600",
                                    // paddingLeft: '6px'
                                  }}
                                >
                                  {row.value}
                                </div>
                              </div>
                            );
                          })}
                          {actionParamRows.length === 0 && (
                            <div
                              style={{
                                paddingTop: "10px",
                                color: "var(--text-muted-color)",
                                fontSize: "90%",
                              }}
                            >
                              No parameters recorded for this action.
                            </div>
                          )}
                          {!actionRef && (
                            <div
                              style={{
                                paddingTop: "10px",
                                color: "var(--text-muted-color)",
                                fontSize: "90%",
                              }}
                            >
                              This action code is not recognized by cloud and
                              can only be removed or deleted here.
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            <div
                              className="button"
                              style={{
                                backgroundColor: actionIsEditable
                                  ? "rgb(112, 179, 125)"
                                  : "rgb(155 155 155)",
                                color: "#fff",
                                marginRight: "5px",
                                marginBottom: "0px",
                                opacity: actionIsEditable ? "1" : "0.7",
                              }}
                              onClick={() => {
                                if (!actionIsEditable) {
                                  return;
                                }
                                const actionEditState =
                                  getActionFormStateForEditing(foundAction);
                                this.setState({
                                  newActionFormActive: true,
                                  newActionFormId: foundAction.id,
                                  newActionName: foundAction.name,
                                  newActionCode: foundAction.code,
                                  ...actionEditState,
                                });
                              }}
                            >
                              Modify
                            </div>
                            <div
                              className="button"
                              style={{
                                backgroundColor: "rgb(155 155 155)",
                                color: "#fff",
                                marginBottom: "0px",
                              }}
                              onClick={() => {
                                const newActions = [...this.state.actions];
                                newActions.splice(actionIndex, 1);
                                this.setState({
                                  actions: newActions,
                                  eventFormHasChanges: true,
                                  activeActionDetailsSectionIndex: null,
                                  newActionFormActive: false,
                                });
                              }}
                            >
                              Remove
                            </div>
                          </div>
                          <div>
                            <div
                              className="button"
                              style={{
                                backgroundColor: "maroon",
                                color: "#fff",
                                marginBottom: "0px",
                                marginLeft: "5px",
                              }}
                              onClick={() => {
                                this.deleteAction(foundAction.id);
                              }}
                            >
                              Delete Action
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
              </React.Fragment>
            )}
          </div>
          {!newEvent && !eventLoading && this.state.id && (
            <div className="cell" style={editorFullWidthStyle}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "10px",
                  marginTop: "20px",
                }}
              >
                <div
                  className="button"
                  style={{
                    backgroundColor: "maroon",
                    color: "#fff",
                    marginBottom: "0px",
                  }}
                  onClick={() => {
                    if (this.state.deleteLoading) {
                      return;
                    }
                    this.deleteEvent(serial)
                  }}
                >
                  {this.state.deleteLoading ? (
                    <Loading white />
                  ) : (
                    "Delete alert permanently"
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      </AppPage>
    );
  }
}

class TriggerParamSection extends React.Component {
  state = {
    helpActive: true,
  };
  renderParamInputs() {
    const { eventForm, setEventFormState } = this.props;

    const foundDevice = this.props.device;

    const {
      outlets,
      banks,
      sensors,
      inlets,
    } = this.props;



    if (!foundDevice) {
      console.log("no device found for trigger param section");
      return [];
    } else {
      const eventRef = eventRefs.find((e) => e.code == eventForm.eventCode);
      if (!eventRef) {
        console.warn("No event ref found");
        return [];
      }
      const paramsToRender = eventRef.params.slice(
        0,
        getEventParamCount(eventRef.code, eventRef, foundDevice?.apiVersion)
      );

      return paramsToRender.map((paramObj, index) => {
        var InputField = Fields[paramObj.input];
        if (!InputField) return null;
        const additionalParams = {};
        const queryParamParams = getParameterByName("params")
          .split(" ")
          .filter((p) => p);

        if (
          (
            (eventCategories.find((c) => c.relResource == "banks") || {})
              .codes || []
          ).includes(eventRef.code) ||
          (
            (
              eventCategories.find((c) => c.relResource == "circuitbreaker") ||
              {}
            ).codes || []
          ).includes(eventRef.code)
        ) {
          additionalParams.options = [
            ...banks
              .map((bank) => ({
                label: bank.bankName,
                value: (bank.id || "").toString(),
              }))
              .filter((opt) => {
                if (queryParamParams.length > 0) {
                  return (
                    opt.value === "any" || queryParamParams.includes(opt.value)
                  );
                } else {
                  return true;
                }
              }),
          ];
        } else if (
          (
            (eventCategories.find((c) => c.relResource == "inlet") || {})
              .codes || []
          ).includes(eventRef.code)
        ) {
          if (eventForm.code == 13 || eventForm.code == 14) {
            // skip for line current
          } else {
            additionalParams.options = [
              ...inlets
                .map((inlet) => ({
                  label: inlet.inletName,
                  value: inlet.id,
                }))
                .filter((opt) => {
                  if (queryParamParams.length > 0) {
                    return queryParamParams.includes(opt.value);
                  } else {
                    return true;
                  }
                }),
            ];
          }
        } else if (
          (
            (eventCategories.find((c) => c.relResource == "outlets") || {})
              .codes || []
          ).includes(eventRef.code)
        ) {
          additionalParams.options = [
            ...outlets
              .map((outlet) => ({
                label: outlet.outletName,
                value: outlet.outlet_id,
              }))
              .filter((opt) => {
                if (queryParamParams.length > 0) {
                  return (
                    opt.value === "any" || queryParamParams.includes(opt.value)
                  );
                } else {
                  return true;
                }
              }),
          ];

          // } else if (((eventCategories.find(c => c.relResource == "groups") || {}).codes || []).includes(eventRef.code)) {
          //   additionalParams.options = [
          //     ...groups.map(group => ({
          //       label: group.groupName,
          //       value: group.id
          //     })).filter(opt => {
          //       if (queryParamParams.length > 0) {
          //         return queryParamParams.includes(opt.value)
          //       } else {
          //         return true;
          //       }
          //     })
          //   ];
        } else if (
          (
            (eventCategories.find((c) => c.relResource == "ioSensors") || {})
              .codes || []
          ).includes(eventRef.code)
        ) {
          if (eventRef.code !== 64) {
            const { foundEvent } = this.props;

            const portToCheck = eventForm.params
              ? eventForm.params[0]
              : (foundEvent.params || [])[0];

            if (portToCheck === "A") {
              const foundSensor = sensors.find((s) => s.sensorPort === "A");
              const isIoHub =
                foundSensor && foundSensor.sensorType === "dio_hub";
              if (foundSensor && isIoHub && index == 1) {
                // only change param #2
                additionalParams.options = [
                  ...foundSensor.digitalInputs.map((di) => ({
                    label: `${di.index}. ${di.digitalInputName}`,
                    value: di.index,
                  })),
                ];
              }
            } else if (portToCheck === "B") {
              const foundSensor = sensors.find((s) => s.sensorPort === "B");
              const isIoHub =
                foundSensor && foundSensor.sensorType === "dio_hub";
              if (foundSensor && isIoHub && index == 1) {
                additionalParams.options = [
                  ...foundSensor.digitalInputs.map((di) => ({
                    label: `${di.index}. ${di.digitalInputName}`,
                    value: di.index,
                  })),
                ];
              }
            }
          }
        } else if (
          (
            (eventCategories.find((c) => c.relResource == "tempSensors") || {})
              .codes || []
          ).includes(eventRef.code)
        ) {
          additionalParams.options = [
            ...sensors.map((sensor) => ({
              label:
                `${sensor.sensorName} (${sensor.sensorId})` ||
                sensor.sensorPort,
              value: sensor.sensorId || sensor.sensorPort,
            })),
          ];
        }
        if (
          index === 2 &&
          paramObj.dynamicNetworkInterface &&
          isApiVersionGte(foundDevice?.apiVersion, "1.2")
        ) {
          const currentValue = (eventForm.params || [])[index];
          additionalParams.options = getNetworkInterfaceOptions(this.props.conf, {
            ensureValues: [currentValue, queryParamParams[index]],
            device: foundDevice,
          });
        }

        const helpSectionitem = (eventRef.helpSections || []).find(
          (h) => h.title === paramObj.label
        );

        const isDynamicNetworkInterface =
          index === 2 &&
          paramObj.dynamicNetworkInterface &&
          isApiVersionGte(foundDevice?.apiVersion, "1.2");
        const valueProp =
          isDynamicNetworkInterface && !(eventForm.params || [])[index]
            ? "default"
            : (eventForm.params || [])[index];

        return (
          <InputField
            key={index}
            {...paramObj}
            type={
              paramObj.input === "number"
                ? "number"
                : paramObj.input === "text"
                ? "text"
                : paramObj.input === "time"
                ? "time"
                : undefined
            }
            {...additionalParams}
            label={`${paramObj.label}${
              paramObj.unit ? ` (${paramObj.unit})` : ""
            }`}
            value={valueProp}
            helpIconAction={
              helpSectionitem
                ? () => this.setState({ helpActive: !this.state.helpActive })
                : null
            }
            callback={(result) => {
              const newParams = [...(eventForm.params || [])];
              newParams[index] =
                isDynamicNetworkInterface && !result ? "default" : result;
              setEventFormState({
                params: newParams,
                eventFormHasChanges: true,
              });
            }}
          />
        );
      });
    }
  }

  render() {
    const eventRef = eventRefs.find(
      (e) => e.code == this.props.eventForm.eventCode
    );
    if (!eventRef) {
      console.warn("No event ref found");
      return null;
    }
    const { helpActive } = this.state;
    const paramInputs = this.renderParamInputs();

    return (
      <div
        style={{
          marginBottom: "10px",
        }}
      >
        <div className="config-header section">
          <h4 className="config-header-title section">{eventRef.name}</h4>
          <div>
            {(eventRef.helpSections || []).length > 0 && (
              <span
                className="white"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.setState({ helpActive: !helpActive });
                }}
              >
                <span
                  style={{
                    marginRight: "-13px",
                  }}
                >
                  <i className="material-icons">
                    {helpActive ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                  </i>
                </span>
                <i className="material-icons">help</i>
              </span>
            )}
          </div>
        </div>
        {helpActive && (eventRef.helpSections || []).length > 0 && (
          <div
            className="app-item"
            style={{
              fontSize: "85%",
              whiteSpace: "pre-line",
              lineHeight: "120%",
            }}
          >
            {(eventRef.helpSections || []).map((section) => {
              return (
                <div
                  key={section.title}
                  style={{
                    marginBottom: "15px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "600",
                      marginBottom: "10px",
                    }}
                  >
                    {section.title}
                  </div>
                  <div>{section.desc}</div>
                </div>
              );
            })}
          </div>
        )}
        <div
          className="app-item"
          style={{
            padding: "18px",
            borderRadius: "0px 0px 3px 3px",
          }}
        >
          {paramInputs.length === 0 && "No Parameters Required"}
          {paramInputs}
        </div>
      </div>
    );
  }
}

class ActionParamSection extends React.Component {
  state = {
    helpActive: false,
  };

  updateCustomFunctionParam = (index, value) => {
    const newParams = [...(this.props.actionForm.params || [])];
    newParams[index] = value;
    this.props.setEventFormState({
      newActionParams: newParams,
      actionFormHasChanges: true,
    });
  };

  renderCustomFunctionParamInputs(actionForm) {
    const {
      actionFormId,
      replaceCustomFunctionScript,
      currentCustomFunctionScriptName,
    } = this.props;
    const normalizedParams = normalizeActionParams(actionForm.params);
    const isEditingExistingAction = Boolean(actionFormId);
    const showReplaceSelector =
      !isEditingExistingAction || replaceCustomFunctionScript;
    const selectedPresetId = getCustomFunctionPresetById(normalizedParams[0])
      ? normalizedParams[0]
      : "";
    const scriptDisplayValue =
      currentCustomFunctionScriptName || normalizedParams[0] || "Not recorded";
    const StaticTextField = Fields.staticText;
    const SelectField = Fields.select;
    const TextAreaField = Fields.textarea;

    return [
      showReplaceSelector ? (
        <SelectField
          key="custom-function-script-preset"
          label="Script Preset"
          value={selectedPresetId}
          options={getCustomFunctionPresetOptions()}
          callback={(result) => {
            this.updateCustomFunctionParam(0, result);
          }}
        />
      ) : (
        <div key="custom-function-current-script">
          <StaticTextField
            label="Script Preset"
            value={scriptDisplayValue}
          />
          <div
            style={{
            }}
          >
            <div
              style={{
                color: "var(--text-muted-color)",
                fontSize: "90%",
                marginBottom: "10px",
              }}
            >
              Editing this action keeps the current device script unless you
              choose to replace it.
            </div>
            <div
              className="button"
              style={{
                backgroundColor: "rgb(112, 179, 125)",
                color: "#fff",
                marginBottom: "0px",
              }}
              onClick={() => {
                this.props.setEventFormState({
                  replaceCustomFunctionScript: true,
                  newActionParams: ["", normalizedParams[1], normalizedParams[2]],
                });
              }}
            >
              Replace Script
            </div>
          </div>
        </div>
      ),
      isEditingExistingAction && replaceCustomFunctionScript && (
        <div
          key="custom-function-replace-warning"
          style={{
          }}
        >
          <div
            style={{
              color: "#92400e",
              backgroundColor: "#fffbeb",
              border: "1px solid #fcd34d",
              borderRadius: "3px",
              padding: "10px",
              fontSize: "90%",
            }}
          >
            Replacing the script will discard the current device script and use
            the selected cloud preset instead.
          </div>
          <div
            className="button"
            style={{
              backgroundColor: "#ddd",
              color: "#333",
              marginBottom: "0px",
              marginTop: "10px",
            }}
            onClick={() => {
              this.props.setEventFormState({
                replaceCustomFunctionScript: false,
                newActionParams: [
                  currentCustomFunctionScriptName,
                  normalizedParams[1],
                  normalizedParams[2],
                ],
              });
            }}
          >
            Keep Current Script
          </div>
        </div>
      ),
      <TextAreaField
        key="custom-function-json-payload"
        label="JSON Payload"
        rows={8}
        placeholder='{"example":"value"}'
        description="Optional JSON payload for the custom function. Maximum 1000 characters."
        validation={validateCustomFunctionJsonPayload}
        value={normalizedParams[1]}
        callback={(result) => {
          this.updateCustomFunctionParam(1, result);
        }}
      />,
    ].filter(Boolean);
  }

  renderParamInputs() {
    const foundDevice = this.props.device
    if (!foundDevice) {
      console.log("no device found for action param section");
      return [];
    } else {
      const outlets = this.props.outlets.filter(
        (o) => o.enclosureSerialNumber == foundDevice.enclosureSerialNumber
      );
      const sensors = this.props.sensors.filter(
        (s) => s.enclosureSerialNumber == foundDevice.enclosureSerialNumber
      );
      const groups = this.props.groups || [];

      const { actionForm } = this.props;

      const postRequestParams = [
        {
          label: "None",
          value: "none",
        },
        {
          label: "Inlet Data",
          value: "inlets", // TODO make this conditional for device
        },
        {
          label: "Sensor Port Data",
          value: "sensors",
        },
      ];
      // if (device.numBanks > 1) {
      postRequestParams.push({
        label: "Circuit Data",
        value: "circuits", // banks
      });
      // }
      if (
        foundDevice.outletPwrMeasurementsSupported ||
        foundDevice.outletSwitchingSupported
      ) {
        postRequestParams.push({
          label: "Outlet Data",
          value: "outlets",
        });
      }

      const actionRef = actionRefs.find((a) => a.code == actionForm.code);
      if (!actionRef || actionRef.params.length === 0) return null;

      // console.log(actionForm)

      var ioHubRelayOutputOptions = [
        {
          label: "Relay Output 1",
          value: "1",
        },
        {
          label: "Relay Output 2",
          value: "2",
        },
        {
          label: "Relay Output 3",
          value: "3",
        },
        {
          label: "Relay Output 4",
          value: "4",
        },
        {
          label: "Relay Output 5",
          value: "5",
        },
        {
          label: "Relay Output 6",
          value: "6",
        },
      ];
      if (actionForm.code == 32 && (actionForm.params || [])[0]) {
        if (actionForm.params[0] === "A" || actionForm.params[0] === "B") {
          let foundIoHubSensor = sensors.find(
            (s) =>
              s.sensorPort === actionForm.params[0] &&
              s.sensorType === "dio_hub"
          );
          if (foundIoHubSensor) {
            ioHubRelayOutputOptions = (foundIoHubSensor.outputRelays || []).map(
              (r) => ({
                // label: `Relay Output ${r.index} - ${r.outputRelayName}`,
                label: `${r.index}. ${r.outputRelayName}`,
                value: r.index,
              })
            );
          }
        }
      }

      const actionParameterInputs = [
        {
          actionCode: 11,
          inputs: [
            {
              inputType: "select",
              options: outlets.map((outlet) => ({
                label: outlet.outletName,
                value: outlet.outlet_id,
              })),
            },
            {
              inputType: "select",
              options: [
                {
                  label: "ON",
                  value: "ON",
                },
                {
                  label: "OFF",
                  value: "OFF",
                },
              ],
            },
          ],
        },
        {
          actionCode: 12,
          inputs: [
            {
              inputType: "select",
              options: outlets.map((outlet) => ({
                label: outlet.outletName,
                value: outlet.outlet_id,
              })),
            },
          ],
        },
          {
            actionCode: 15,
            inputs: [
              {
                inputType: "text",
                placeholder: "eg: support@synaccess-net.com",
              },
            ],
          },
          {
            actionCode: 16,
            inputs: [
              {
                inputType: "select",
                options: groups.map((group) => ({
                  label: group.groupName,
                  value: group.id,
                })),
              },
              {
                inputType: "select",
                options: [
                  {
                    label: "ON",
                    value: "ON",
                  },
                  {
                    label: "OFF",
                    value: "OFF",
                  },
                ],
              },
            ],
          },
          {
            actionCode: 17,
            inputs: [
              {
                inputType: "select",
                options: groups.map((group) => ({
                  label: group.groupName,
                  value: group.id,
                })),
              },
            ],
          },
          {
            actionCode: 18,
            inputs: [
              {
                inputType: "text",
              description: "Format: HOST:PORT - Default SNMP Trap Port: 162",
              placeholder: "ex: 192.168.1.101:162",
            },
            {
              inputType: "text",
              placeholder: "ex: public",
            },
          ],
        },
        {
          actionCode: 19,
          inputs: [
            {
              inputType: "text",
              description: "Format: HOST:PORT - Default SNMP Trap Port: 162",
              placeholder: "ex: 192.168.1.101:162",
            },
          ],
        },
        {
          actionCode: 20,
          inputs: [
            {
              inputType: "text",
              placeholder: "",
            },
            {
              inputType: "select",
              options: postRequestParams,
            },
          ],
        },
        {
          actionCode: 21,
          inputs: [
            {
              inputType: "text",
              placeholder: "16192098077",
            },
          ],
          // },{
          //   actionCode: 22,
          //   inputs: [{
          //     inputType: "select",
          //     options: relayOutputs.map(relayOutput => ({
          //       label: relayOutput.relayName,
          //       value: relayOutput.id
          //     }))
          //   }, {
          //     inputType: "select",
          //     options: [{
          //       label: "ON",
          //       value: "ON"
          //     }, {
          //       label: "OFF",
          //       value: "OFF"
          //     }]
          //   }]
          // },{
          //   actionCode: 23,
          //   inputs: [{
          //     inputType: "select",
          //     options: relayOutputs.map(relayOutput => ({
          //       label: relayOutput.relayName,
          //       value: relayOutput.id
          //     }))
          //   }]
        },
        {
          actionCode: 24,
          inputs: [
            {
              inputType: "text",
              description: "Format: HTTP_TYPE://HOST:PORT ",
              placeholder: "ex: http://192.168.1.100:80",
            },
            {
              inputType: "text",
              description: "Format: outlet index or outlet id ",
              placeholder: "ex: 2",
            },
            {
              inputType: "text",
              description: "Format: PAT from Other PDU ",
              placeholder: "cqf0u5mtzDFfG2yCKJA",
              type: "password",
            },
          ],
        },
        {
          actionCode: 25,
          inputs: [
            {
              inputType: "text",
              description: "Format: HTTP_TYPE://HOST:PORT ",
              placeholder: "ex: http://192.168.1.100:80",
            },
            {
              inputType: "text",
              description: "Format: outlet index or outlet id ",
              placeholder: "ex: 2",
            },
            {
              inputType: "text",
              description: "Format: PAT from Other PDU ",
              placeholder: "cqf0u5mtzDFfG2yCKJA",
              type: "password",
            },
          ],
        },
        {
          actionCode: 26,
          inputs: [
            {
              inputType: "text",
              description: "Format: HTTP_TYPE://HOST:PORT ",
              placeholder: "ex: http://192.168.1.100:80",
            },
            {
              inputType: "text",
              description: "Format: outlet group index or outlet group id ",
              placeholder: "ex: 2",
            },
            {
              inputType: "text",
              description: "Format: PAT from Other PDU ",
              placeholder: "cqf0u5mtzDFfG2yCKJA",
              type: "password",
            },
          ],
        },
        {
          actionCode: 27,
          inputs: [
            {
              inputType: "text",
              description: "Format: HTTP_TYPE://HOST:PORT ",
              placeholder: "ex: http://192.168.1.100:80",
            },
            {
              inputType: "text",
              description: "Format: outlet group index or outlet group id ",
              placeholder: "ex: 2",
            },
            {
              inputType: "text",
              description: "Format: PAT from Other PDU ",
              placeholder: "cqf0u5mtzDFfG2yCKJA",
              type: "password",
            },
          ],
        },
        {
          actionCode: 28,
          inputs: [
            {
              inputType: "text",
              description: "Format: HTTP_TYPE://HOST:PORT ",
              placeholder: "ex: http://192.168.1.100:80",
            },
            {
              inputType: "text",
              description: "Format: outlet index or outlet id ",
              placeholder: "ex: 2",
            },
            {
              inputType: "text",
              description: "Format: PAT from Other PDU ",
              placeholder: "cqf0u5mtzDFfG2yCKJA",
              type: "password",
            },
          ],
        },
        {
          actionCode: 29,
          inputs: [
            {
              inputType: "text",
              description: "Format: HTTP_TYPE://HOST:PORT ",
              placeholder: "ex: http://192.168.1.100:80",
            },
            {
              inputType: "text",
              description: "Format: outlet group index or outlet group id ",
              placeholder: "ex: 2",
            },
            {
              inputType: "text",
              description: "Format: PAT from Other PDU ",
              placeholder: "cqf0u5mtzDFfG2yCKJA",
              type: "password",
            },
          ],
        },
        {
          actionCode: 30,
          inputs: [
            {
              inputType: "select",
              options: [
                {
                  label: "Disabled",
                  value: "disabled",
                },
                {
                  label: "Bridge Mode",
                  value: "bridge_mode",
                },
              ],
            },
          ],
        },
        {
          actionCode: 32,
          inputs: [
            {
              inputType: "select",
              options: [
                {
                  label: "Sensor Port A",
                  value: "A",
                },
                {
                  label: "Sensor Port B",
                  value: "B",
                },
              ],
            },
            {
              inputType: "select",
              options: ioHubRelayOutputOptions,
            },
            {
              inputType: "select",
              options: [
                {
                  label: "OPEN (NO-COM)",
                  value: "OPEN",
                },
                {
                  label: "CLOSE (NC-COM)",
                  value: "CLOSE",
                },
              ],
            },
          ],
        },
        {
          actionCode: CUSTOM_FUNCTION_ACTION_CODE,
          inputs: [
            {
              inputType: "select",
              options: getCustomFunctionPresetOptions(),
            },
            {
              inputType: "textarea",
              rows: 8,
              placeholder: '{"example":"value"}',
              description: "Optional JSON payload for the custom function. Maximum 1000 characters.",
              validation: validateCustomFunctionJsonPayload,
            },
          ],
          // }, {
          //   actionCode: 31,
          //   inputs: [{
          //     inputType: "number",
          //     // type: "number"
          //     // description:

          //   }]
        },
      ];

      const foundActionParameterInputs = actionParameterInputs.find(
        (paramObj) => paramObj.actionCode === actionRef.code
      );
      if (!foundActionParameterInputs) return null;

      if (actionRef.code === CUSTOM_FUNCTION_ACTION_CODE) {
        return this.renderCustomFunctionParamInputs(actionForm);
      }

      return foundActionParameterInputs.inputs.map(
        (actionParamInput, index) => {
          const actionParamValue = (actionForm.params || [])[index];
          var shouldIncludeHelpIcon =
            (actionRef.helpSections || []).filter((h) => h.paramIndex === index)
              .length > 0;
          var InputField = Fields[actionParamInput.inputType];
          if (!InputField) return null;
          return (
            <InputField
              key={index}
              {...actionParamInput}
              helpIconAction={
                shouldIncludeHelpIcon
                  ? () => this.setState({ helpActive: !this.state.helpActive })
                  : null
              }
              label={actionRef.params[index]}
              value={actionParamValue}
              callback={(result) => {
                const newParams = [...(actionForm.params || [])];
                newParams[index] = result;
                this.props.setEventFormState({
                  newActionParams: newParams,
                  actionFormHasChanges: true,
                });
              }}
            />
          );
        }
      );
    }
  }

  render() {
    const { actionForm } = this.props;

    const actionRef = actionRefs.find((a) => a.code == actionForm.code);
    if (!actionRef || actionRef.params.length === 0) {
      console.log("no action ref found");
      return null;
    }

    return (
      <div>
        <div>
          {(actionRef.helpSections || []).length > 0 && (
            <div
              // className="app-item"
              style={{
                fontSize: "85%",
                whiteSpace: "pre-line",
                lineHeight: "120%",
              }}
            >
              {(actionRef.helpSections || []).map((section) => {
                return (
                  <div
                    key={section.title}
                    style={{
                      marginBottom: "15px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        marginBottom: "10px",
                      }}
                    >
                      {section.title}
                    </div>
                    <div>{section.desc}</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div>{this.renderParamInputs()}</div>
      </div>
    );
  }
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = (name || "").replace(
    /[[\]]/g, //     /[\[\]]/g,
    "\\$&"
  );
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return ""; // null
  if (!results[2]) return "";
  return decodeURIComponent((results[2] || "").replace(/\+/g, " "));
}
